const appendServerUrl = (url) => `${process.env.REACT_APP_SERVER_URL}/billing/api/${url}`;

const baseAPI = (sessionToken) => {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `${sessionToken}`,
  };

  const apiService = {
    execute: async (url, options = { method: 'GET' }) => {
      const fullUrl = appendServerUrl(url);
      const { body, ...restOptions } = options;

      return new Promise((resolve, reject) => {
        fetch(fullUrl, { headers, ...restOptions, body: JSON.stringify(body) })
          .then((response) => {
            if (!response.ok) {
              return response.json().then((err) => Promise.reject(err));
            }

            return response.json();
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    get: (url) => apiService.execute(url),
    post: (url, body = {}) => apiService.execute(url, { method: 'POST', body }),
    put: (url, body = {}) => apiService.execute(url, { method: 'PUT', body }),
    delete: (url, body = {}) => apiService.execute(url, { method: 'DELETE', body }),
  };

  return apiService;
};

export default baseAPI;
